import { computed } from "vue";

export const ButtonType = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    CA_GREEN: 'ca-green',
    CA_ACCENT_GREEN: 'ca-accent-green',
    LINK: 'link',
    DANGER: 'danger',
    DISCREET: 'discreet',
    UPSELL: 'upsell'
};

export const buttonStyleProps = {
    size: {type: String, default: ''},
    type: {type: String, default: ButtonType.PRIMARY}
};

export const useButtonStyles = (type, size) => {
    const sizeClass = computed(() => {
        switch (size.value) {
            case 'full': return 'btn-block';
            case 'half': return 'w-50';
            case 'small': return 'btn-sm';
        }
        return '';
    });

    const typeClasses = computed(() => {
        switch (type.value) {
            case ButtonType.SECONDARY: return 'v-btn btn btn-secondary';
            case ButtonType.CA_GREEN: return 'v-btn btn btn-ca-green';
            case ButtonType.CA_ACCENT_GREEN: return 'v-btn btn btn-ca-accent-green';
            case ButtonType.LINK: return 'v-btn btn btn-link';
            case ButtonType.DANGER: return 'v-btn btn btn-danger';
            case ButtonType.DISCREET: return 'v-btn btn btn-discreet';
            case ButtonType.UPSELL: return 'v-btn btn btn-upsell';
        }
        return 'v-btn btn btn-primary';
    });

    return {
        sizeClass,
        typeClasses
    };
};